var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetTaskPeriodicity } from '@/shared/hooks/task/useGetTaskPeriodicity';
import guid from '@/shared/utils/guid';
import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import AutoComplete from '../select/AutoComplete';
export var TaskPeriodicitySelect = function (_a) {
    var initialValue = _a.initialValue, placeholder = _a.placeholder, taskTemplateId = _a.taskTemplateId, isDisabled = _a.isDisabled, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var _b = useGetTaskPeriodicity(taskTemplateId), data = _b.data, refetch = _b.refetch;
    useEffect(function () {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskTemplateId]);
    var taskPeriodicitys = useMemo(function () {
        return data === null || data === void 0 ? void 0 : data.map(function (item) { return ({
            key: item.id,
            label: formatMessage(listItemMsg('taskperiodicity', item.id, item.name)),
        }); });
    }, [data, formatMessage]);
    var allItems = useMemo(function () { return __spreadArray([
        {
            key: guid.empty,
            label: formatMessage({ id: 'NoPeriodicity', defaultMessage: 'No periodicity' }),
        }
    ], (taskPeriodicitys !== null && taskPeriodicitys !== void 0 ? taskPeriodicitys : []), true); }, [taskPeriodicitys, formatMessage]);
    var initialSelectedItem = useMemo(function () { var _a; return (_a = (initialValue && (allItems === null || allItems === void 0 ? void 0 : allItems.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === initialValue; })))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, allItems]);
    return (_jsx(AutoComplete, { items: allItems, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: function (item) { return onChange(item === null || item === void 0 ? void 0 : item.key); }, disabled: isDisabled }));
};
export var FilterTaskPeriodicitySelect = function (_a) {
    var _b;
    var item = _a.item, taskTemplatesItem = _a.taskTemplatesItem, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    var taskTemplates = (_b = activeFilters[taskTemplatesItem]) !== null && _b !== void 0 ? _b : [];
    var taskTemplateId = taskTemplates.length === 1 ? taskTemplates[0] : null;
    return {
        enabled: enabled,
        filterItem: item,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(TaskPeriodicitySelect, { onChange: function (value) {
                var _a;
                return setFilter((_a = {}, _a[item] = value !== null && value !== void 0 ? value : undefined, _a));
            }, initialValue: activeFilters[item], taskTemplateId: taskTemplateId, placeholder: label, isDisabled: !taskTemplateId })),
    };
};
